"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientPage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _org = require('shared/selectors/org');
var _peers = require('shared/selectors/peers');
var _patientApp = require('shared/selectors/patientApp');
var _user = require('shared/selectors/user');



var _entities = require('shared/transforms/entities');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _useEntityPreload = require('shared/hooks/useEntityPreload'); var _useEntityPreload2 = _interopRequireDefault(_useEntityPreload);
var _usePatientConsent = require('shared/hooks/usePatientConsent'); var _usePatientConsent2 = _interopRequireDefault(_usePatientConsent);
var _phone = require('shared/services/phone');
var _consent = require('shared/services/consent');









var _smsDelivery = require('shared/services/smsDelivery');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');



var _Header = require('web/components/RightSide/Header');
var _Tooltip = require('web/components/Tooltip');
var _RightSide = require('web/components/RightSide');
var _DirectoryPage = require('web/screens/Directory/DirectoryPage');
var _EntityNotFoundScreen = require('web/screens/EntityNotFoundScreen'); var _EntityNotFoundScreen2 = _interopRequireDefault(_EntityNotFoundScreen);
var _Avatar = require('web/components/Avatar');
var _NameBadge = require('web/components/NameBadge'); var _NameBadge2 = _interopRequireDefault(_NameBadge);
var _InfoSection = require('./InfoSection'); var _InfoSection2 = _interopRequireDefault(_InfoSection);
var _RecentChatsSection = require('web/screens/Directory/RecentChatsSection'); var _RecentChatsSection2 = _interopRequireDefault(_RecentChatsSection);
var _Forms = require('web/screens/Directory/Forms');
var _SMSResubscribeModal = require('web/components/SMSResubscribeModal'); var _SMSResubscribeModal2 = _interopRequireDefault(_SMSResubscribeModal);
var _SMSMarkOptedOutModal = require('web/components/SMSMarkOptedOutModal'); var _SMSMarkOptedOutModal2 = _interopRequireDefault(_SMSMarkOptedOutModal);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _useUserNameOf = require('web/screens/Directory/hooks/useUserNameOf'); var _useUserNameOf2 = _interopRequireDefault(_useUserNameOf);
var _TextingSection = require('./TextingSection'); var _TextingSection2 = _interopRequireDefault(_TextingSection);
var _AccessHistory = require('./AccessHistory'); var _AccessHistory2 = _interopRequireDefault(_AccessHistory);
var _ConsentSection = require('./ConsentSection');
var _RecordConsentModal = require('./RecordConsentModal'); var _RecordConsentModal2 = _interopRequireDefault(_RecordConsentModal);
























const PatientPage = ({
  patientKey,
  orgKey,
  onStartChat,
  onRequestPatientsFeature,
  panel,
}) => {
  const orgName = _hooks.useAppSelector.call(void 0, state => _optionalChain([_org.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _ => _.Name]) || '')
  const patient = _hooks.useAppSelector.call(void 0, state => _peers.selectPatientByKey.call(void 0, state, patientKey))
  const patientEntity = _react.useMemo.call(void 0, 
    () => patient
      ? _entities.mapPatientToEntity.call(void 0, {}, (0, _entities.makeContactPatientDescription))(patient)
      : null,
    [patient],
  )
  const hasPatientMessaging =
    _hooks.useAppSelector.call(void 0, state => _org.selectOrgHasPatientMessagingFeature.call(void 0, state, orgKey))
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  const hasConsent = _hooks.useAppSelector.call(void 0, state => _org.selectOrgHasConsent.call(void 0, state, orgKey))

  const {
    isOpen: isEditFormOpen,
    onOpen: onOpenEditForm,
    onClose: onCloseEditForm,
  } = _useToggle2.default.call(void 0, )
  const {
    isOpen: isResubscribeOpen,
    onOpen: onOpenResubscribe,
    onClose: onCloseResubscribe,
  } = _useToggle2.default.call(void 0, )
  const {
    isOpen: isMarkOptedOutOpen,
    onOpen: onOpenMarkOptedOut,
    onClose: onCloseMarkOptedOut,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isRecordConsentOpen,
    onOpen: onOpenRecordConsent,
    onClose: onCloseRecordConsent,
  } = _useToggle2.default.call(void 0, )

  const {
    isOpen: isBlockOpen,
    onOpen: onOpenBlock,
    onClose: onCloseBlock,
  } = _useToggle2.default.call(void 0, )
  const [isClearing, setIsClearing] = _react.useState.call(void 0, false)
  const [isBlocking, setIsBlocking] = _react.useState.call(void 0, false)

  const isAppUser = _hooks.useAppSelector.call(void 0, state => _patientApp.selectIsPatientAppUser.call(void 0, state, patientKey))
  const phone = _optionalChain([patient, 'optionalAccess', _2 => _2.Phone]) || ''
  const smsRows = _react.useMemo.call(void 0, () => _smsDelivery.sortSMSUndeliverable.call(void 0, _optionalChain([patient, 'optionalAccess', _3 => _3.SMSUndeliverable]) || []), [_optionalChain([patient, 'optionalAccess', _4 => _4.SMSUndeliverable])])
  const orgRows = _react.useMemo.call(void 0, () => smsRows.filter(r => !r.Shared), [smsRows])
  const isOptedOut = orgRows.some(r => r.Reason === 'opted_out')
  const isAdminBlocked = orgRows.some(r => r.Reason === 'admin_blocked')
  // Reloads when the texting rows change, so an opt-out or resubscribe shows.
  const { view: consent, update: setConsent } =
    _usePatientConsent2.default.call(void 0, orgKey, patientKey, hasConsent, _optionalChain([patient, 'optionalAccess', _5 => _5.SMSUndeliverable]))
  // In a consent org, Resubscribe on a texted STOP records "asked again".
  const textedStop = hasConsent ? _nullishCoalesce(orgRows.find(_consent.isTextedStop), () => ( null)) : null

  // Who added a staff or admin row, from the org's users already loaded.
  const nameOf = _useUserNameOf2.default.call(void 0, )

  const loadPatient =
    _react.useCallback.call(void 0, () => _actions2.default.getPatient({ PatientKey: patientKey }), [patientKey])

  const loadRecentChats = _react.useCallback.call(void 0, 
    (_query, Offset, Limit) => _actions2.default
      .getInboxForPatient({ PatientKey: patientKey, Offset, Limit }),
    [patientKey],
  )

  const hasLoadFailed = _useEntityPreload2.default.call(void 0, loadPatient)

  const onNewChat = _react.useMemo.call(void 0, 
    () => {
      if (!hasPatientMessaging && !amIAdmin) return null
      return hasPatientMessaging
        ? patientEntity && (() => onStartChat(patientEntity))
        : onRequestPatientsFeature
    },
    [
      hasPatientMessaging, amIAdmin,
      onRequestPatientsFeature,
      onStartChat, patientEntity,
    ],
  )

  const { showWarningBar, showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onSubmit = _react.useCallback.call(void 0, 
    ({ firstName, lastName, dob, email, phone, foreignID }) =>
      _actions2.default.updatePatient({
        PatientKey: patientKey,
        FirstName: firstName,
        LastName: lastName,
        DateOfBirth: dob,
        Email: email,
        Phone: phone,
        ForeignID: foreignID,
      })
        .then(onCloseEditForm)
        .then(() => showSuccessBar('Patient information updated'))
        .catch(() => showWarningBar('Failed to update patient information')),
    [patientKey, onCloseEditForm, showSuccessBar, showWarningBar],
  )

  const textedStopLine = textedStop ? _phone.formatPhoneNumber.call(void 0, textedStop.SendingNumber) || 'your number' : ''
  const onResubscribeSMS = _react.useCallback.call(void 0, 
    (reason, askedAgain) => _actions2.default.resubscribePatientSMS({
      OrgKey: orgKey,
      PatientKey: patientKey,
      ConfirmedPatientConsent: true,
      Reason: reason,
      ...(askedAgain && { How: askedAgain.how, AskedOn: askedAgain.askedOn }),
    })
      .then(() => {
        onCloseResubscribe()
        showSuccessBar(askedAgain
          ? _consent.makeAskedAgainSavedCopy.call(void 0, _optionalChain([patient, 'optionalAccess', _6 => _6.Name]), textedStopLine)
          : 'Patient resubscribed to texts')
      })
      .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to resubscribe patient'))),
    [orgKey, patientKey, onCloseResubscribe, showSuccessBar, showWarningBar, _optionalChain([patient, 'optionalAccess', _7 => _7.Name]), textedStopLine],
  )

  const onRecordConsent = _react.useCallback.call(void 0, 
    ({ how, date, note }) => _actions2.default.recordPatientConsent({
      OrgKey: orgKey,
      PatientKey: patientKey,
      How: how,
      Date: date,
      ...(note && { Note: note }),
    })
      .then(view => {
        setConsent(view)
        onCloseRecordConsent()
        showSuccessBar('Consent recorded')
      })
      .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to record consent'))),
    [orgKey, patientKey, setConsent, onCloseRecordConsent, showSuccessBar, showWarningBar],
  )

  const onClearSMS = _react.useCallback.call(void 0, 
    (action) => {
      if (action === 'ResubscribePatientSMS') return onOpenResubscribe()
      setIsClearing(true)
      if (action === 'ClearPatientSMSUnreachable') {
        _actions2.default.clearPatientSMSUnreachable({ OrgKey: orgKey, PatientKey: patientKey })
          .then(() => showSuccessBar(_smsDelivery.SMS_CLEAR_UNREACHABLE_SUCCESS))
          .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, _smsDelivery.SMS_CLEAR_UNREACHABLE_FAILURE)))
          .finally(() => setIsClearing(false))
        return
      }
      _actions2.default.unblockPatientSMS({ OrgKey: orgKey, PatientKey: patientKey })
        .then(() => showSuccessBar('Number unblocked'))
        .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to unblock number')))
        .finally(() => setIsClearing(false))
    },
    [orgKey, patientKey, onOpenResubscribe, showSuccessBar, showWarningBar],
  )

  const onBlockSMS = _react.useCallback.call(void 0, 
    () => {
      setIsBlocking(true)
      _actions2.default.blockPatientSMS({ OrgKey: orgKey, PatientKey: patientKey })
        .then(() => {
          onCloseBlock()
          showSuccessBar('Number blocked')
        })
        .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to block number')))
        .finally(() => setIsBlocking(false))
    },
    [orgKey, patientKey, onCloseBlock, showSuccessBar, showWarningBar],
  )

  const remainingCopy = _react.useMemo.call(void 0, 
    () => _smsDelivery.makeSMSResubscribeRemainingCopy.call(void 0, _optionalChain([patient, 'optionalAccess', _8 => _8.Name]), smsRows),
    [_optionalChain([patient, 'optionalAccess', _9 => _9.Name]), smsRows],
  )

  const onMarkSMSOptedOut = _react.useCallback.call(void 0, 
    (reason) => _actions2.default.markPatientSMSOptedOut({
      OrgKey: orgKey,
      PatientKey: patientKey,
      Reason: reason,
    })
      .then(() => {
        onCloseMarkOptedOut()
        showSuccessBar('Patient marked opted out of SMS')
      })
      .catch(e => showWarningBar(_smsDelivery.smsPreferenceErrorMessage.call(void 0, e, 'Failed to mark patient opted out'))),
    [orgKey, patientKey, onCloseMarkOptedOut, showSuccessBar, showWarningBar],
  )

  const onMarkOptedOut = isOptedOut ? null : onOpenMarkOptedOut
  const onBlock = amIAdmin && !isAdminBlocked ? onOpenBlock : null
  // In the panel the occasional actions wait in the header's More menu, the
  // destructive one last, so the card and the foot keep only the everyday ones.
  const hasPanelMenu = !!panel && !!(onMarkOptedOut || onBlock || panel.menuItem)

  if (hasLoadFailed) return _react2.default.createElement(_EntityNotFoundScreen2.default, { desc: "Failed to load patient"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 285}} )
  if (!patientEntity) return null

  return (
    _react2.default.createElement(_react2.default.Fragment, { key: patientKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 289}}
      , _react2.default.createElement(_Header.RightSideHeader, { className: "chat-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
        ,  !panel && _react2.default.createElement(_Header.HeaderMobileBackButton, { onClick: _actions2.default.gotoDirectory, __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}} ) 
        , _react2.default.createElement(_Avatar.PatientAvatar, { patientKey: patientKey, size: 40, isAppUser: isAppUser, __self: this, __source: {fileName: _jsxFileName, lineNumber: 292}} )
        , _react2.default.createElement(_Header.RightSideHeaderHeading, {
          title: patientEntity.name || patientEntity.description,
          titleBadge: isAppUser ? _react2.default.createElement(_NameBadge2.default, { label: "App user" , className: "blm-name--badge--as-written", __self: this, __source: {fileName: _jsxFileName, lineNumber: 295}} ) : null,
          subtitle: orgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}}
        )
        ,  onNewChat && (
          _react2.default.createElement(_Header.HeaderItem, {
            iconName: "chat",
            'aria-label': "Start a chat"  ,
            className: "blmh-mobile-hide",
            onClick: onNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}}
          )
        )
        ,  hasPanelMenu && (
          _react2.default.createElement(_Header.HeaderMoreToggle, { className: "dir-drawer--more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 307}}
            ,  onMarkOptedOut && (
              _react2.default.createElement(_Tooltip.TooltipMenuItem, {
                iconSrc: "/assets/icons/alert-grey.svg",
                label: _smsDelivery.SMS_MARK_OPTED_OUT_TITLE,
                onClick: onMarkOptedOut, __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}}
              )
            )
            ,  panel.menuItem 
            ,  onBlock && (
              _react2.default.createElement(_Tooltip.TooltipMenuItem, {
                isDestructive: true,
                iconSrc: "/assets/icons/alert-orange.svg",
                label: _smsDelivery.SMS_BLOCK_PATIENT_LABEL,
                onClick: onBlock, __self: this, __source: {fileName: _jsxFileName, lineNumber: 317}}
              )
            )
          )
        )
        ,  panel && (
          _react2.default.createElement('button', { 'aria-label': "Close", className: "dir-drawer--close", type: "button", onClick: panel.onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}
            , _react2.default.createElement('img', { alt: "", src: "/assets/icons/icon-cross-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 328}} )
          )
        )
      )
      , _react2.default.createElement(_RightSide.RightSideBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 332}}
        , _react2.default.createElement(_DirectoryPage.DirectoryPage, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 333}}
          , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 334}}, "General Information"

          )
          , _react2.default.createElement('div', { className: "directory-page--section directory--patient--section" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}
            ,  isEditFormOpen
              ? (
                  _react2.default.createElement(_Forms.PatientForm, {
                    patientKey: patientKey,
                    onSubmit: onSubmit,
                    onCancel: onCloseEditForm,
                    submitBtnLabel: "Save",
                    controlsClassName: "directory-page--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 340}}
                  )
                )
              : (
                  _react2.default.createElement(_InfoSection2.default, {
                    patientKey: patientKey,
                    patientName: patientEntity.name,
                    orgName: orgName,
                    dob: _optionalChain([patientEntity, 'access', _10 => _10.wrappedEntity, 'optionalAccess', _11 => _11.DateOfBirth]),
                    phone: _optionalChain([patientEntity, 'access', _12 => _12.wrappedEntity, 'optionalAccess', _13 => _13.Phone]),
                    email: _optionalChain([patientEntity, 'access', _14 => _14.wrappedEntity, 'optionalAccess', _15 => _15.Email]),
                    foreignID: _optionalChain([patientEntity, 'access', _16 => _16.wrappedEntity, 'optionalAccess', _17 => _17.ForeignID]),
                    onEdit: onOpenEditForm,
                    compact: panel && { created: panel.created },
                    texting: (
                      _react2.default.createElement(_TextingSection2.default, {
                        rows: smsRows,
                        isAdmin: amIAdmin,
                        nameOf: nameOf,
                        onMarkOptedOut: panel ? null : onMarkOptedOut,
                        onBlock: panel ? null : onBlock,
                        onClear: onClearSMS,
                        isClearing: isClearing,
                        consent: consent,
                        onRecordConsent: _consent.canRecordConsent.call(void 0, consent) ? onOpenRecordConsent : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 360}}
                      )
                    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}}
                  )
                )
            
          )
          ,  consent && _react2.default.createElement(_ConsentSection.ConsentHistory, { consent: consent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 376}} ) 
          ,  _nullishCoalesce(_optionalChain([panel, 'optionalAccess', _18 => _18.sections]), () => ( (
            _react2.default.createElement(_AccessHistory2.default, { orgKey: orgKey, patientKey: patientKey, patientName: patientEntity.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 378}} )
          )))
          , _react2.default.createElement(_RecentChatsSection2.default, {
            loadItemsList: loadRecentChats,
            onNewChat: onNewChat,
            entityName: patientEntity.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 380}}
          )
        )
      )
      ,  _optionalChain([panel, 'optionalAccess', _19 => _19.footer]) 
      , _react2.default.createElement(_SMSResubscribeModal2.default, {
        isOpen: isResubscribeOpen,
        patientName: patientEntity.name,
        remainingCopy: remainingCopy,
        isAskedAgain: !!textedStop,
        onClose: onCloseResubscribe,
        onConfirm: onResubscribeSMS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 388}}
      )
      , _react2.default.createElement(_RecordConsentModal2.default, {
        isOpen: isRecordConsentOpen,
        patientName: patientEntity.name,
        onClose: onCloseRecordConsent,
        onConfirm: onRecordConsent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 396}}
      )
      , _react2.default.createElement(_SMSMarkOptedOutModal2.default, {
        isOpen: isMarkOptedOutOpen,
        orgKey: orgKey,
        patientKey: patientKey,
        patientName: patientEntity.name,
        onClose: onCloseMarkOptedOut,
        onConfirm: onMarkSMSOptedOut, __self: this, __source: {fileName: _jsxFileName, lineNumber: 402}}
      )
      , _react2.default.createElement(_Modal2.default, {
        isOpen: isBlockOpen,
        onClose: onCloseBlock,
        title: _smsDelivery.SMS_BLOCK_PATIENT_LABEL,
        size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 410}}

        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 416}},  _smsDelivery.makeSMSBlockPatientConfirmCopy.call(void 0, patientEntity.name, phone) )
        , _react2.default.createElement(_Modal.ModalControls, {
          primaryBtnTheme: "danger",
          primaryBtnLabel: "Block",
          secondaryBtnLabel: "Cancel",
          isPrimaryLoading: isBlocking,
          isPrimaryEnabled: !isBlocking,
          onPrimaryBtnClick: onBlockSMS,
          onSecondaryBtnClick: onCloseBlock, __self: this, __source: {fileName: _jsxFileName, lineNumber: 417}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PatientPage)
